<div class="view-calculation-container" [class.view-calculation-container--cabinet]="!!section">
  <header class="page-head" [class.page-head--cabinet]="!!section">
    <div class="page-head__top">
      <button
        *ngIf="showBackButton"
        (click)="onBack()"
        class="back-link"
        type="button"
      >
        <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M12 4l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        {{ backText }}
      </button>
      <!-- В кабинете метка ИИ — в блоке с итогом «Стоимости поставки» -->
      <span *ngIf="calculation?.completedWithAi && !section" class="ai-badge">{{ completedWithAiText }}</span>
    </div>

    <div class="page-head__main">
      <div class="page-head__titles">
        <!-- Телефон/планшет: меню спрятано за ☰ — возврат к сводке одним касанием -->
        <a class="cabinet-back" *ngIf="section && section !== 'overview' && calculation"
           [routerLink]="['/calculations', calculation.id, 'overview']">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12 4l-6 6 6 6"/></svg>
          {{ st('calcSections.overview', 'Стоимость поставки') }}
        </a>
        <h1 *ngIf="section; else calcTitleTpl">{{ sectionTitle }}</h1>
        <ng-template #calcTitleTpl>
          <h1>{{ calculation ? (calculation.title || (calculationFallbackPrefixText + calculation.id)) : titleText }}</h1>
        </ng-template>
        <!-- Кабинет клиента: учётный номер и дата с подписями, без внутреннего статуса -->
        <p class="page-head__meta" *ngIf="calculation && section">
          <span *ngIf="calculation.title">{{ calculation.title }}</span>
          <span>{{ st('calcSections.accountNumber', 'Учётный номер') }}: <strong>№ {{ calculation.id }}</strong></span>
          <span>{{ st('calcSections.date', 'Дата') }}: <strong>{{ calculation.createdAt | date:'dd.MM.yyyy HH:mm' }}</strong></span>
        </p>
        <p class="page-head__meta" *ngIf="calculation && !section">
          <span class="status-chip" [class]="'status-chip status-chip--' + ((calculation.status || 'CREATED') | lowercase)">{{ statusLabel(calculation.status) }}</span>
          <span>№ {{ calculation.id }}</span>
          <span>{{ calculation.createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
        </p>
      </div>
      <div class="page-head__actions">
        <ng-content select="[headerActions]"></ng-content>
      </div>
    </div>

    <!-- Дорожная карта расчёта: шаги — разделы, у каждого — что сейчас нужно от пользователя -->
    <nav class="calc-progress" *ngIf="section && calculation" [attr.aria-label]="st('calcSections.progressLabel', 'Дорожная карта расчёта')">
      <!-- Телефон: одна строка вместо четырёх плашек — сумма остаётся на первом экране -->
      <div class="calc-progress__compact" *ngIf="progressSteps as steps">
        <button type="button" class="progress-summary" (click)="progressOpen = !progressOpen" [attr.aria-expanded]="progressOpen">
          <span class="progress-summary__dots" aria-hidden="true">
            <span *ngFor="let step of steps" class="progress-dot" [ngClass]="'progress-dot--' + step.state"></span>
          </span>
          <span class="progress-summary__count">
            {{ st('calcSections.progressDone', 'Готово {done} из {total}').replace('{done}', '' + progressDoneCount).replace('{total}', '' + steps.length) }}
          </span>
          <svg class="progress-summary__chevron" [class.progress-summary__chevron--open]="progressOpen" viewBox="0 0 20 20" aria-hidden="true"><path d="M5 7.5l5 5 5-5"/></svg>
        </button>
        <a class="progress-next" *ngIf="progressNext as next" [class.progress-next--action]="next.state === 'action'"
           [routerLink]="['/calculations', calculation!.id, next.id]">
          <span class="progress-next__label">{{ st('calcSections.next', 'Дальше') }}:</span>
          <strong>{{ next.title }}</strong>
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 4l6 6-6 6"/></svg>
        </a>
        <span class="progress-next progress-next--done" *ngIf="!progressNext">✓ {{ st('calcSections.progressAllDone', 'Все шаги готовы') }}</span>
      </div>

      <ol class="calc-progress__list" [class.calc-progress__list--open]="progressOpen">
        <li *ngFor="let step of progressSteps; let i = index">
          <a class="calc-progress__step" [ngClass]="'calc-progress__step--' + step.state"
             [class.calc-progress__step--active]="section === step.id"
             [attr.aria-current]="section === step.id ? 'page' : null"
             [routerLink]="['/calculations', calculation!.id, step.id]">
            <span class="calc-progress__dot" aria-hidden="true">
              <svg *ngIf="step.state === 'done'" viewBox="0 0 20 20"><path d="M5 10.5l3.5 3.5L15 7"/></svg>
              <ng-container *ngIf="step.state === 'action'">!</ng-container>
              <ng-container *ngIf="step.state === 'wait' || step.state === 'info'">{{ i + 1 }}</ng-container>
            </span>
            <span class="calc-progress__text">
              <strong>{{ step.title }}</strong>
              <small>{{ step.text }}</small>
            </span>
          </a>
        </li>
      </ol>
    </nav>
  </header>

  <div *ngIf="loading" class="loading-message">{{ loadingText }}</div>
  <div *ngIf="error" class="error-message">{{ error }}</div>

  <div *ngIf="!loading && !error && calculation" class="calculation-details">

    <!-- ── Карточка товаров (инвойс или ручной ввод). Для владельца проецируется в панель, для брокера/поставщика — отдельно ── -->
    <ng-template #editorTpl>
      <app-invoice-editor
        *ngIf="calculation!.products && calculation!.products.length > 0"
        [calculation]="calculation!"
        [incotermReadonly]="isBroker() || isSupplier()"
        [viewOnly]="readOnly"
        (calculationUpdated)="onInvoiceUpdated($event)"
        (incotermChange)="onInvoiceIncotermChange($event)"
      ></app-invoice-editor>
    </ng-template>

    <ng-container *ngIf="isBroker() || isSupplier() || section === 'invoice'">
      <ng-container *ngTemplateOutlet="editorTpl"></ng-container>
    </ng-container>

    <!-- ── «Товары доставит продавец?» — в разделе «Прогноз перевозки», над формой доставки.
         От ответа зависит, входит ли доставка в таможенную стоимость; условия поставки в инвойсе не меняем. ── -->
    <div class="seller-question" *ngIf="section === 'freight'">
      <h3 class="seller-question__title" id="seller-question-title">{{ st('calcSections.sellerQuestion', 'Товары доставит в вашу страну продавец (производитель)?') }}</h3>
      <div class="seller-question__choice" role="radiogroup" aria-labelledby="seller-question-title">
        <button type="button" role="radio" class="choice-btn" [class.choice-btn--on]="sellerDelivers === true" [disabled]="sellerSaving || readOnly"
                [attr.aria-checked]="sellerDelivers === true" (click)="setSellerDelivers(true)">{{ st('calcSections.yes', 'Да') }}</button>
        <button type="button" role="radio" class="choice-btn" [class.choice-btn--on]="sellerDelivers === false" [disabled]="sellerSaving || readOnly"
                [attr.aria-checked]="sellerDelivers === false" (click)="setSellerDelivers(false)">{{ st('calcSections.no', 'Нет') }}</button>
      </div>
      <p class="seller-question__error" *ngIf="sellerError" role="alert">{{ sellerError }}</p>
      <p class="seller-question__why" *ngIf="!sellerAnswered">{{ st('calcSections.sellerWhy', 'Зачем мы спрашиваем: если доставку до вашей страны оплачивает продавец, она уже входит в цену товара. Если нет — часть расходов на доставку добавится к таможенной стоимости, и пошлина с НДС будут выше.') }}</p>

      <p class="seller-question__answer seller-question__answer--ok" *ngIf="sellerAnswered && sellerDelivers">
        {{ st('calcSections.answerYes', 'Доставка входит в цену товара — добавлять её к таможенной стоимости не нужно.') }}
      </p>
      <ng-container *ngIf="sellerDelivers === false">
        <p class="seller-question__answer seller-question__answer--ok" *ngIf="deliveryTotal !== null">
          {{ st('calcSections.answerNoDone', 'Доставка до границы (аэропорта) учтена — таможенные платежи посчитаны с ней.') }}
        </p>
        <div class="seller-question__answer seller-question__answer--todo" *ngIf="deliveryTotal === null">
          <p>{{ st('calcSections.answerNoTodo', 'Заполните данные ниже, чтобы узнать прогнозную стоимость доставки. Это также поможет точнее рассчитать предварительные таможенные платежи.') }}</p>
        </div>
      </ng-container>
    </div>

    <!-- ── Кабинет: уточнение по товарам — над результатом; после сохранения уходит в карточку товара ── -->
    <section class="refine-top" *ngIf="section === 'payments' && pendingRefineProducts.length">
      <div class="refine-top__head">
        <span class="refine-top__chip">{{ st('calcSections.refineChip', 'Нужно уточнение') }}</span>
        <span class="refine-top__count" *ngIf="pendingRefineProducts.length > 1">
          {{ st('calcSections.refineCount', 'Товаров: {n}').replace('{n}', '' + pendingRefineProducts.length) }}
        </span>
      </div>
      <h2 class="refine-top__title">{{ st('calcSections.refineTitle', 'Ответьте на вопросы — посчитаем пошлину точнее') }}</h2>

      <ng-container *ngIf="topRefineProduct as p; else refineResumeTpl">
        <p class="refine-top__product">{{ p.nameForBroker || p.nameOriginal }}</p>
        <ng-container *ngTemplateOutlet="refineQuestionsTpl"></ng-container>
        <ng-container *ngTemplateOutlet="refineActionsTpl; context: { inline: false }"></ng-container>
      </ng-container>
      <ng-template #refineResumeTpl>
        <button type="button" class="refine-btn refine-btn--ghost" (click)="openRefine(pendingRefineProducts[0])">
          {{ st('calcSections.refineResume', 'Продолжить уточнение') }}
        </button>
      </ng-template>
    </section>

    <!-- Кнопки уточнения: сохранить = сразу пересчитать -->
    <ng-template #refineActionsTpl let-inline="inline">
      <div class="refine-actions" *ngIf="!readOnly">
        <button type="button" class="refine-btn" [disabled]="refineLoading || !canSubmitRefine()" (click)="saveRefine()">
          {{ refineLoading ? st('calcSections.refineSaving', 'Пересчитываем...') : st('calcSections.refineSave', 'Сохранить') }}
        </button>
        <button type="button" class="refine-btn refine-btn--ghost" *ngIf="inline" [disabled]="refineLoading" (click)="cancelInlineRefine()">{{ cancelText }}</button>
        <span class="refine-actions__hint">{{ st('calcSections.refineHint', 'Расчёт обновится сразу после сохранения.') }}</span>
      </div>
      <div *ngIf="refineError" class="refine-error" role="alert">{{ refineError }}</div>
    </ng-template>

    <!-- Вопросы уточнения (общие для старой панели и кабинета) -->
    <ng-template #refineQuestionsTpl>
          <div class="refine-panel__questions">
            <p *ngIf="getRefineQuestions().length === 0" class="refine-panel__desc">
              {{ refineNoQuestionsText }}
            </p>
            <ng-container *ngFor="let q of getRefineQuestions()">
              <div class="refine-question" *ngIf="isQuestionVisible(q)">
                <label class="refine-question__label">
                  {{ q.label }}
                  <span *ngIf="q.required" class="required-mark">*</span>
                </label>
                <p *ngIf="q.hint" class="refine-question__hint">{{ q.hint }}</p>

                <!-- COUNTRY_SELECT / SINGLE_SELECT — Radio group -->
                <div
                  *ngIf="q.type === 'COUNTRY_SELECT' || q.type === 'SINGLE_SELECT'"
                  class="refine-radio-group"
                >
                  <label
                    *ngFor="let opt of q.options"
                    class="refine-radio-option"
                    [class.refine-radio-option--selected]="refineAnswers[q.id] === opt.value"
                  >
                    <input
                      type="radio"
                      [name]="'q_' + q.id"
                      [value]="opt.value"
                      [(ngModel)]="refineAnswers[q.id]"
                      [ngModelOptions]="{ standalone: true }"
                      [disabled]="readOnly"
                      (change)="onAnswerChange(q.id, getRefineQuestions())"
                    />
                    <span class="refine-radio-label">{{ opt.label }}</span>
                    <span *ngIf="opt.rateHint" class="refine-rate-hint">{{ opt.rateHint }}</span>
                  </label>
                </div>

                <!-- QUANTITY_INPUT — число -->
                <div *ngIf="q.type === 'QUANTITY_INPUT'" class="refine-qty-input">
                  <input
                    type="number"
                    min="0"
                    step="0.001"
                    class="table-input number-input"
                    [placeholder]="enterPrefixText + ' ' + (q.unit || defaultUnitText)"
                    [(ngModel)]="refineAnswers[q.id]"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="readOnly"
                  />
                  <span class="refine-unit" *ngIf="q.unit">{{ q.unit }}</span>
                </div>

                <!-- BOOLEAN — Да / Нет -->
                <div *ngIf="q.type === 'BOOLEAN'" class="refine-radio-group">
                  <label
                    *ngFor="let opt of q.options"
                    class="refine-radio-option"
                    [class.refine-radio-option--selected]="refineAnswers[q.id] === opt.value"
                  >
                    <input
                      type="radio"
                      [name]="'q_' + q.id"
                      [value]="opt.value"
                      [(ngModel)]="refineAnswers[q.id]"
                      [ngModelOptions]="{ standalone: true }"
                      [disabled]="readOnly"
                      (change)="onAnswerChange(q.id, getRefineQuestions())"
                    />
                    <span class="refine-radio-label">{{ opt.label }}</span>
                    <span *ngIf="opt.rateHint" class="refine-rate-hint">{{ opt.rateHint }}</span>
                  </label>
                </div>
              </div>
            </ng-container>
          </div>

    </ng-template>

    <!-- ── Сводная панель: поставка + итоги ────────────────────────────────── -->
    <app-calculation-summary-panel
      *ngIf="!isBroker() && !isSupplier() && section !== 'invoice' && section !== 'overview'"
      mode="loaded"
      [section]="section"
      [viewOnly]="readOnly"
      [detailsAvailable]="!section"
      [calculation]="calculation"
      [detailsOpen]="detailsOpen"
      [saving]="shipmentSaving"
      [estimatingDelivery]="estimatingDelivery"
      [deliveryEstimateError]="deliveryEstimateError"
      (shipmentInfoChange)="onShipmentInfoChange($event)"
      (toggleDetails)="onToggleDetails()"
      (startCertificatesCheck)="runCertificatesCheck()"
      (estimateDeliveryCostRequested)="onEstimateDeliveryCost($event)"
    >
      <ng-container *ngIf="!section"><ng-container *ngTemplateOutlet="editorTpl"></ng-container></ng-container>
    </app-calculation-summary-panel>

    <!-- ── Комментарий брокера ───────────────────────────────────────────── -->
    <div class="broker-comment-section" *ngIf="(isBroker() || calculation.brokerComment) && (!section || section === 'overview')">
      <h2>{{ brokerCommentSectionTitleText }}</h2>
      <textarea
        *ngIf="isBroker(); else brokerCommentReadonly"
        [(ngModel)]="brokerCommentDraft"
        [ngModelOptions]="{ standalone: true }"
        class="broker-comment-input"
        rows="4"
        [placeholder]="brokerCommentPlaceholderText"
      ></textarea>
      <ng-template #brokerCommentReadonly>
        <p>{{ calculation.brokerComment || '-' }}</p>
      </ng-template>
      <button
        *ngIf="isBroker()"
        type="button"
        class="btn btn-primary"
        [disabled]="brokerSavingComment"
        (click)="saveBrokerComment()"
      >
        {{ brokerSavingComment ? savingEllipsisText : saveBrokerCommentText }}
      </button>
      <div *ngIf="brokerError" class="broker-error">{{ brokerError }}</div>
      <div *ngIf="brokerSuccess" class="broker-success">{{ brokerSuccess }}</div>
    </div>

    <!-- ── Баннер приблизительного расчёта ──────────────────────────────── -->
    <div class="approximate-banner" *ngIf="hasApproximateProducts() && !section">
      <span class="approximate-banner__icon">⚠</span>
      <div>
        <strong>{{ preliminaryNoticeTitleText }}</strong>
        <p>{{ preliminaryNoticeBodyText }}</p>
      </div>
    </div>

    <!-- ── Таблица товаров ───────────────────────────────────────────────── -->
    <section class="products-section" [class.products-section--cabinet]="section === 'payments'" *ngIf="isBroker() || detailsOpen || section === 'payments'">
      <h2>{{ section === 'payments' ? st('calcSections.byProducts', 'По товарам') : productsText }}</h2>

      <!-- Кабинет: товар — карточка вместо широкой таблицы -->
      <ul class="pay-products" *ngIf="section === 'payments' && calculation.products?.length">
        <li class="pay-product" *ngFor="let product of calculation.products; let i = index"
            [class.row-active]="refineProductId === product.id && !!product.refined">
          <div class="pay-product__head">
            <div class="pay-product__name">
              <span class="pay-product__num">{{ i + 1 }}</span>
              <strong [title]="product.nameForBroker || product.nameOriginal">{{ product.nameForBroker || product.nameOriginal }}</strong>
            </div>
            <div class="pay-product__total">
              <span>{{ totalPaymentsText }}</span>
              <strong>{{ fmt(product.totalCustomsPayments) }} ₸</strong>
            </div>
          </div>

          <div class="pay-product__code">
            {{ tnvedCodeText }}: <b>{{ product.tnvedCodeForBroker || product.tnvedCodeOriginal || '—' }}</b>
            <span *ngIf="product.tnvedCodeInDictionary" class="pay-product__ok" [title]="codeInDictionaryTitleText">✓</span>
            <span *ngIf="product.tnvedCodeInDictionary === false" class="code-not-found-badge">{{ codeNotFoundText }}</span>
            <span *ngIf="product.exciseExcluded" class="excise-excluded-badge" [title]="exciseNotCalculatedTitleText">{{ exciseNotCalculatedBadgeText }}</span>
            <!-- После уточнения — значок: открыть ответы снова -->
            <button type="button" class="pay-product__edit" *ngIf="product.refined && hasFollowUpQuestions(product)" [disabled]="readOnly"
                    [class.pay-product__edit--on]="refineProductId === product.id"
                    (click)="refineProductId === product.id ? cancelInlineRefine() : openRefine(product)"
                    [title]="st('calcSections.refineEdit', 'Изменить уточнение')" [attr.aria-label]="st('calcSections.refineEdit', 'Изменить уточнение')">
              <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 6h8M15 6h2M3 14h2M9 14h8"/><circle cx="13" cy="6" r="2"/><circle cx="7" cy="14" r="2"/></svg>
              <span>{{ st('calcSections.refineDone', 'Уточнено') }}</span>
            </button>
          </div>

          <dl class="pay-product__grid">
            <div>
              <dt>{{ productCostText }}</dt>
              <dd>{{ fmt(product.productCostKzt ?? product.productCost) }} ₸</dd>
            </div>
            <div>
              <dt>{{ customsFeesText }}</dt>
              <dd>{{ fmt(product.customsFees) }} ₸</dd>
            </div>
            <div>
              <dt [title]="dutyRateHint(product)">{{ customsDutyText }}<ng-container *ngIf="dutyRateLabel(product) as rate"> · {{ rate }}</ng-container></dt>
              <dd>{{ fmt(product.customsDuty) }} ₸<span *ngIf="product.approximate" class="approx-badge" [title]="approximateHint(product)"> ~</span></dd>
            </div>
            <div>
              <dt>{{ vatText }} · {{ vatPercent }}%</dt>
              <dd>{{ fmt(product.vat) }} ₸</dd>
            </div>
          </dl>

          <!-- Уточнённый товар: правка ответов прямо в карточке -->
          <div class="pay-product__inline-refine" *ngIf="product.refined && refineProductId === product.id">
            <ng-container *ngTemplateOutlet="refineQuestionsTpl"></ng-container>
            <ng-container *ngTemplateOutlet="refineActionsTpl; context: { inline: true }"></ng-container>
          </div>
        </li>
      </ul>

      <div *ngIf="!calculation.products || calculation.products.length === 0" class="empty-products">
        <p>{{ noProductsText }}</p>
      </div>

      <div class="table-scroll" *ngIf="calculation.products && calculation.products.length > 0 && section !== 'payments'">
      <table class="products-table">
        <thead>
          <tr>
            <th>{{ productNameText }}</th>
            <th>{{ productCostText }}</th>
            <th>{{ tnvedCodeText }}</th>
            <th>{{ customsFeesText }}</th>
            <th>{{ customsDutyText }}</th>
            <th>{{ vatText }}</th>
            <th>{{ totalPaymentsText }}</th>
            <th *ngIf="!isBroker()">{{ actionsText }}</th>
            <th *ngIf="isBroker()">{{ brokerActionsText }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of calculation.products"
              [class.row-active]="refineProductId === product.id || certProductId === product.id">

            <!-- Название -->
            <td class="cell-name" [attr.data-label]="productNameText">
              <input
                *ngIf="isBroker(); else productNameReadonly"
                type="text"
                class="table-input name-input"
                [(ngModel)]="getEditableProduct(product).nameForBroker"
                [ngModelOptions]="{ standalone: true }"
              />
              <ng-template #productNameReadonly>
                <span>{{ product.nameForBroker || product.nameOriginal }}</span>
              </ng-template>
              <div class="product-scope" *ngIf="product.applicationScope">{{ product.applicationScope }}</div>
              <div class="product-ai" *ngIf="product.aiProductDescription">{{ aiIdentifiedAsText }}: {{ product.aiProductDescription }}</div>
            </td>

            <!-- Стоимость -->
            <td [attr.data-label]="productCostText">
              <input
                *ngIf="isBroker(); else productCostReadonly"
                type="number"
                class="table-input number-input"
                min="0"
                step="0.01"
                [(ngModel)]="getEditableProduct(product).productCost"
                [ngModelOptions]="{ standalone: true }"
              />
              <ng-template #productCostReadonly>
                <span *ngIf="product.productCostKzt != null">{{ product.productCostKzt | number:'1.2-2' }} ₸</span>
                <span *ngIf="product.productCostKzt == null">{{ product.productCost | number:'1.2-2' }} ₸</span>
              </ng-template>
            </td>

            <!-- ТНВЭД -->
            <td [attr.data-label]="tnvedCodeText">
              <input
                *ngIf="isBroker(); else tnvedReadonly"
                type="text"
                class="table-input code-input"
                [(ngModel)]="getEditableProduct(product).tnvedCodeForBroker"
                [ngModelOptions]="{ standalone: true }"
              />
              <ng-template #tnvedReadonly>
                {{ product.tnvedCodeForBroker || product.tnvedCodeOriginal || '-' }}
                <span *ngIf="product.tnvedCodeInDictionary" class="in-dictionary-badge" [title]="codeInDictionaryTitleText">✓</span>
                <span *ngIf="product.tnvedCodeInDictionary === false" class="code-not-found-badge">{{ codeNotFoundText }}</span>
                <span *ngIf="product.rateSource" class="rate-source-badge rate-source-{{ product.rateSource | lowercase }}">
                  {{ rateSourceLabel(product) }}
                </span>
                <span
                  *ngIf="product.exciseExcluded"
                  class="excise-excluded-badge"
                  [title]="exciseNotCalculatedTitleText"
                >{{ exciseNotCalculatedBadgeText }}</span>
              </ng-template>
            </td>

            <!-- Сбор -->
            <td [attr.data-label]="customsFeesText">
              <input
                *ngIf="isBroker(); else feesReadonly"
                type="number"
                class="table-input number-input"
                min="0"
                step="0.01"
                [(ngModel)]="getEditableProduct(product).customsFees"
                [ngModelOptions]="{ standalone: true }"
              />
              <ng-template #feesReadonly>{{ product.customsFees ? (product.customsFees | number:'1.2-2') + ' ₸' : '-' }}</ng-template>
            </td>

            <!-- Пошлина -->
            <td [attr.data-label]="customsDutyText">
              <input
                *ngIf="isBroker(); else dutyReadonly"
                type="number"
                class="table-input number-input"
                min="0"
                step="0.01"
                [(ngModel)]="getEditableProduct(product).customsDuty"
                [ngModelOptions]="{ standalone: true }"
              />
              <ng-template #dutyReadonly>
                <span>{{ product.customsDuty != null ? (product.customsDuty | number:'1.2-2') + ' ₸' : '-' }}</span>
                <span *ngIf="product.customsDutyPercent != null" class="duty-pct">
                  ({{ product.customsDutyPercent | number:'1.0-2' }}%)
                </span>
                <span
                  *ngIf="product.approximate"
                  class="approx-badge"
                  [title]="approximateHint(product)"
                >⚠ ~</span>
              </ng-template>
            </td>

            <!-- НДС -->
            <td [attr.data-label]="vatText">
              <input
                *ngIf="isBroker(); else vatReadonly"
                type="number"
                class="table-input number-input"
                min="0"
                step="0.01"
                [(ngModel)]="getEditableProduct(product).vat"
                [ngModelOptions]="{ standalone: true }"
              />
              <ng-template #vatReadonly>{{ product.vat ? (product.vat | number:'1.2-2') + ' ₸' : '-' }}</ng-template>
            </td>

            <!-- Итого -->
            <td class="total-cell" [attr.data-label]="totalPaymentsText">
              <input
                *ngIf="isBroker(); else totalReadonly"
                type="number"
                class="table-input number-input"
                min="0"
                step="0.01"
                [(ngModel)]="getEditableProduct(product).totalCustomsPayments"
                [ngModelOptions]="{ standalone: true }"
              />
              <ng-template #totalReadonly>
                {{ product.totalCustomsPayments ? (product.totalCustomsPayments | number:'1.2-2') + ' ₸' : '-' }}
              </ng-template>
            </td>

            <!-- Действия -->
            <td class="row-actions" *ngIf="!isBroker()">
              <!-- Кнопка уточнить (шаг 2): есть вопросы или расчёт приблизительный -->
              <button
                *ngIf="hasFollowUpQuestions(product) || product.approximate"
                type="button"
                class="btn btn-step2"
                [class.btn-step2--active]="refineProductId === product.id"
                [class.btn-step2--done]="product.refined && refineProductId !== product.id"
                (click)="openRefine(product)"
                [title]="refineButtonTitleText"
              >
                <ng-container [ngSwitch]="true">
                  <ng-container *ngSwitchCase="refineProductId === product.id">{{ refineCloseLabelText }}</ng-container>
                  <ng-container *ngSwitchCase="!!product.refined">{{ refineDoneLabelText }}</ng-container>
                  <ng-container *ngSwitchDefault>{{ refineOpenLabelText }}</ng-container>
                </ng-container>
              </button>

              <!-- Кнопка документы — только если ТНВЭД определён. Никакого запроса к бэку:
                   просто показывает уже загруженные calculation.certificateChecklists для кода товара. -->
              <button
                *ngIf="(product.tnvedCodeForBroker || product.tnvedCodeOriginal) && !section"
                type="button"
                class="btn btn-cert"
                [class.btn-cert--active]="certProductId === product.id"
                (click)="toggleCertPanel(product)"
                [title]="certificatesTitleAttrText"
              >
                {{ certProductId === product.id ? certificatesCloseLabelText : certificatesOpenLabelText }}
              </button>
            </td>

            <!-- Действия брокера -->
            <td *ngIf="isBroker()" class="row-actions">
              <button
                type="button"
                class="btn btn-primary btn-small"
                [disabled]="savingProducts[product.id] || deletingProducts[product.id]"
                (click)="saveProduct(product)"
              >
                {{ savingProducts[product.id] ? '...' : saveText }}
              </button>
              <button
                type="button"
                class="btn btn-danger btn-small"
                [disabled]="savingProducts[product.id] || deletingProducts[product.id]"
                (click)="deleteProduct(product)"
              >
                {{ deletingProducts[product.id] ? '...' : deleteText }}
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total-row">
            <td colspan="6" class="total-label">{{ totalAllPaymentsText }}:</td>
            <td class="total-amount" [attr.data-label]="totalAllPaymentsText">{{ getTotalAmount() | number:'1.2-2' }} ₸</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      </div>

      <!-- ── Панель уточнённого расчёта (шаг 2) ─────────────────────────── -->
      <div class="refine-panel" *ngIf="refineProductId !== null && section !== 'payments'">
        <div class="refine-panel__header">
          <h3>{{ refineSectionTitleText }}</h3>
          <button type="button" class="btn-close" (click)="closeRefine()">✕</button>
        </div>

        <p class="refine-panel__desc">{{ refineSectionDescriptionText }}</p>

        <ng-container *ngTemplateOutlet="refineQuestionsTpl"></ng-container>

        <div class="refine-panel__actions">
          <button
            type="button"
            class="btn btn-secondary"
            [disabled]="refinePreviewLoading || refineLoading || !canSubmitRefine()"
            (click)="previewRefine()"
            [title]="refinePreviewButtonTitleText"
          >
            {{ refinePreviewLoading ? calculatingText : calculateButtonText }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="refinePreviewLoading || refineLoading || !canSubmitRefine()"
            (click)="saveRefine()"
            [title]="refineSaveButtonTitleText"
          >
            {{ refineLoading ? savingEllipsisText : saveButtonWithIconText }}
          </button>
          <button type="button" class="btn btn-secondary" (click)="closeRefine()">{{ cancelText }}</button>
        </div>

        <div *ngIf="refineError" class="broker-error">{{ refineError }}</div>

        <!-- Результат расчёта (предварительный или сохранённый) -->
        <div class="refine-result" [class.refine-result--preview]="!refineResultSaved" *ngIf="refineResult">
          <h4>{{ refineResultSaved ? savedText : previewResultUnsavedText }}</h4>
          <table class="refine-result-table">
            <tbody>
              <tr *ngIf="refineResult.countryOfOrigin">
                <td>{{ countryOfOriginText }}</td>
                <td><strong>{{ refineResult.countryOfOrigin }}</strong></td>
              </tr>
              <tr>
                <td>{{ dutyRateText }}</td>
                <td><strong>{{ refineResult.customsDutyPercent | number:'1.2-2' }} %</strong></td>
              </tr>
              <tr>
                <td>{{ customsDutyText }}</td>
                <td>{{ refineResult.customsDuty | number:'1.2-2' }} ₸</td>
              </tr>
              <tr *ngIf="refineResult.excise">
                <td>{{ exciseText }}</td>
                <td>{{ refineResult.excise | number:'1.2-2' }} ₸</td>
              </tr>
              <tr *ngIf="refineResult.antiDumpingDuty">
                <td>{{ antiDumpingDutyText }}</td>
                <td>{{ refineResult.antiDumpingDuty | number:'1.2-2' }} ₸</td>
              </tr>
              <tr>
                <td>{{ vatText }}</td>
                <td>{{ refineResult.vat | number:'1.2-2' }} ₸</td>
              </tr>
              <tr class="refine-result-total">
                <td><strong>{{ totalCustomsPaymentsFullText }}</strong></td>
                <td><strong>{{ refineResult.totalCustomsPayments | number:'1.2-2' }} ₸</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ── Панель документов по выбранному товару — без запроса к бэку,
             показывает уже загруженные данные по коду ТНВЭД этого товара ──── -->
      <div class="cert-panel" *ngIf="!section && certPanelProduct as certPanelProd">
        <div class="cert-panel__header">
          <h3>{{ certificatesTitleAttrText }} — {{ certPanelProd.nameForBroker || certPanelProd.nameOriginal }}</h3>
          <button type="button" class="btn-close" (click)="certProductId = null">✕</button>
        </div>

        <ng-container *ngIf="getChecklistForProduct(certPanelProd) as certResult; else certPanelNotChecked">
          <p class="cert-panel__code">
            {{ tnvedColonLabelText }} <strong>{{ certResult.tnvedCode }}</strong>
            <span *ngIf="certResult.tnvedName"> — {{ certResult.tnvedName }}</span>
          </p>

          <div *ngIf="certResult.ntrNotFound" class="cert-not-found">
            {{ noNonTariffDataText }}
          </div>

          <div *ngIf="!certResult.ntrNotFound" class="cert-checklist">
            <p *ngIf="certResult.requiredDocuments.length === 0" class="cert-none">
              {{ noDocumentsRequiredText }}
            </p>

            <ul class="cert-list" *ngIf="certResult.requiredDocuments.length > 0">
              <li *ngFor="let doc of certResult.requiredDocuments" class="cert-yes">
                <span class="cert-list__icon">✓</span>
                <span class="cert-list__name">{{ doc.name }}</span>
              </li>
            </ul>

            <div class="cert-notes" *ngIf="certResult.notes">
              <p><strong>{{ noteLabelText }}</strong> {{ certResult.notes }}</p>
            </div>

            <p class="cert-disclaimer" *ngIf="certResult.aiGenerated">
              {{ aiDisclaimerText }}
            </p>
          </div>
        </ng-container>

        <ng-template #certPanelNotChecked>
          <p class="cert-panel__code">
            {{ tnvedColonLabelText }} <strong>{{ certPanelProd.tnvedCodeForBroker || certPanelProd.tnvedCodeOriginal }}</strong>
          </p>
          <div class="cert-not-checked">
            <p>{{ certificatesCheckNotDoneText }}</p>
            <button type="button" class="btn btn-secondary" [disabled]="certificatesChecking"
                    (click)="runCertificatesCheck()">
              {{ certificatesChecking ? certificatesCheckingText : certificatesRunCheckText }}
            </button>
          </div>
        </ng-template>
      </div>

      <!-- ── Итоговый дисклеймер ─────────────────────────────────────────── -->
      <p class="pay-disclaimer" *ngIf="section === 'payments'">
        <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 9v4.5M10 6.5v.01"/></svg>
        {{ st('calcSections.grandTotalDisclaimer', 'Расчёт предварительный. Итоговую сумму таможенных платежей утверждает таможенный орган при оформлении декларации.') }}
      </p>
      <div class="detailed-assessment-info" *ngIf="calculation?.completedWithAi && section !== 'payments'">
        <p>{{ detailedAssessmentText }}</p>
        <p class="whatsapp-contact">
          <a [href]="whatsappUrl" target="_blank" rel="noopener noreferrer">{{ whatsappContactText }}</a>
        </p>
      </div>
    </section>

    <!-- ── Раздел «Разрешительные документы»: документы по каждому товару ──── -->
    <section class="cabinet-section permits-list" *ngIf="section === 'permits'">
      <article class="permit-card" *ngFor="let product of calculation.products; let i = index">
        <header class="permit-card__head">
          <div class="permit-card__title">
            <span class="permit-card__num">{{ i + 1 }}</span>
            <h3 [title]="product.nameForBroker || product.nameOriginal">{{ product.nameForBroker || product.nameOriginal }}</h3>
          </div>
          <ng-container *ngIf="getChecklistForProduct(product) as certResult">
            <span class="permit-chip permit-chip--ok" *ngIf="!certResult.ntrNotFound && certResult.requiredDocuments.length === 0">
              {{ st('calcSections.permitsChipNone', 'Не требуются') }}
            </span>
            <span class="permit-chip permit-chip--need" *ngIf="!certResult.ntrNotFound && certResult.requiredDocuments.length > 0">
              {{ st('calcSections.permitsChipNeed', 'Документов: {n}').replace('{n}', '' + certResult.requiredDocuments.length) }}
            </span>
          </ng-container>
        </header>
        <p class="permit-card__code" *ngIf="product.tnvedCodeForBroker || product.tnvedCodeOriginal">
          {{ tnvedCodeText }}: <b>{{ product.tnvedCodeForBroker || product.tnvedCodeOriginal }}</b>
        </p>

        <ng-container *ngIf="getChecklistForProduct(product) as certResult; else permitNotChecked">
          <p class="permit-card__name" *ngIf="cleanTnvedName(certResult.tnvedName) as tnName">{{ tnName }}</p>
          <div *ngIf="certResult.ntrNotFound" class="permit-empty">{{ noNonTariffDataText }}</div>
          <ng-container *ngIf="!certResult.ntrNotFound">
            <p *ngIf="certResult.requiredDocuments.length === 0" class="permit-empty permit-empty--ok">
              {{ st('calcSections.permitsNoneText', 'По имеющимся данным дополнительные разрешительные документы не требуются.') }}
            </p>
            <ul class="permit-docs" *ngIf="certResult.requiredDocuments.length > 0">
              <li *ngFor="let doc of certResult.requiredDocuments">
                <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M6 2.5h5.5L15 6v11.5H6z"/><path d="M11.5 2.5V6H15M8.5 10h4M8.5 13h4"/></svg>
                <span>{{ doc.name }}</span>
              </li>
            </ul>
            <div class="permit-notes" *ngIf="certResult.notes">
              <strong>{{ noteLabelText }}</strong> {{ certResult.notes }}
            </div>
          </ng-container>
        </ng-container>

        <ng-template #permitNotChecked>
          <p class="cert-not-checked__text" *ngIf="product.tnvedCodeForBroker || product.tnvedCodeOriginal; else permitNoCode">{{ certificatesCheckNotDoneText }}</p>
          <ng-template #permitNoCode><p class="cert-not-checked__text">{{ st('calcSections.permitsNoCode', 'Код ТН ВЭД ещё не определён — документы проверим после классификации.') }}</p></ng-template>
        </ng-template>
      </article>

      <!-- Одна пометка на раздел вместо мелкого курсива в каждой карточке -->
      <div class="permit-ai-note">
        <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 9v4.5M10 6.5v.01"/></svg>
        <div>
          <p>{{ st('calcSections.permitsAiNote', 'Перечень подготовлен искусственным интеллектом на основе нормативных актов ЕАЭС и может быть неполным. Точный список документов подтвердит таможенный брокер в сопровождении Bilload. Если документы нужны, их оформление можно заказать прямо на платформе Bilload.') }}</p>
          <a class="permit-ai-note__link" *ngIf="!calculation.status || calculation.status === 'CREATED'" [routerLink]="['/calculations', calculation.id, 'support']">
            {{ st('calcSections.startShipment', 'Заказать сопровождение') }}
            <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12M11 5l5 5-5 5"/></svg>
          </a>
        </div>
      </div>
    </section>

    <!-- ── Раздел «Стоимость поставки»: все расходы на одном экране ─────────── -->
    <section class="cabinet-section overview" *ngIf="section === 'overview'">
      <!-- Итог — главный результат расчёта: сумма крупно и синим -->
      <div class="overview-total">
        <div class="overview-total__top">
          <span class="overview-total__label">{{ st('calcSections.grandTotal', 'Ориентировочная стоимость поставки') }}</span>
          <span class="overview-total__ai" *ngIf="calculation.completedWithAi">{{ completedWithAiText }}</span>
        </div>
        <strong class="overview-total__value">≈ {{ fmt(grandTotalKzt) }} ₸</strong>
        <span class="overview-total__note">{{ freightPending
          ? st('calcSections.freightNotIncluded', 'Без учёта доставки и прочих расходов')
          : st('calcSections.otherNotIncluded', 'Без учёта прочих расходов') }}</span>
      </div>

      <!-- Основные расходы: каждая строка ведёт в свой раздел с подробностями -->
      <div class="cost-group cost-group--main">
        <h3 class="overview-group">{{ st('calcSections.mainCosts', 'Основные расходы') }}</h3>
        <ul class="cost-list">
          <li>
            <a class="cost-row" [routerLink]="['/calculations', calculation.id, 'invoice']">
              <span class="cost-row__label">{{ st('calcSections.invoiceValue', 'Инвойсная стоимость товаров') }}</span>
              <strong class="cost-row__value">{{ fmt((calculation.totalProductCostKzt ?? 0)) }} ₸</strong>
              <svg class="cost-row__chevron" viewBox="0 0 20 20" aria-hidden="true"><path d="M8 5l5 5-5 5"/></svg>
            </a>
          </li>
          <li>
            <a class="cost-row" [routerLink]="['/calculations', calculation.id, 'payments']">
              <span class="cost-row__label">
                {{ st('calcSections.prelimPayments', 'Предварительные таможенные платежи') }}
                <small *ngIf="freightPending">{{ st('calcSections.paymentsWillGrow', 'могут вырасти после учёта доставки') }}</small>
              </span>
              <strong class="cost-row__value">{{ fmt((calculation.totalCustomsPayments ?? 0)) }} ₸</strong>
              <svg class="cost-row__chevron" viewBox="0 0 20 20" aria-hidden="true"><path d="M8 5l5 5-5 5"/></svg>
            </a>
          </li>
          <li>
            <a class="cost-row" [routerLink]="['/calculations', calculation.id, 'freight']">
              <span class="cost-row__label">{{ st('calcSections.freightForecast', 'Прогноз стоимости перевозки') }}</span>
              <strong class="cost-row__value" *ngIf="sellerDelivers === true; else freightValue">
                <span class="cost-row__muted">{{ st('calcSections.inPrice', 'входит в цену товара') }}</span>
              </strong>
              <ng-template #freightValue>
                <strong class="cost-row__value" *ngIf="deliveryTotal !== null; else freightTodo">
                  {{ fmt(deliveryTotal) }} {{ deliveryCurrency }}
                  <small *ngIf="deliveryCurrency !== 'KZT' && deliveryKzt !== null">≈ {{ fmt(deliveryKzt) }} ₸</small>
                </strong>
                <ng-template #freightTodo>
                  <span class="cost-row__action">{{ st('calcSections.estimateFreight', 'Рассчитать') }}</span>
                </ng-template>
              </ng-template>
              <svg class="cost-row__chevron" viewBox="0 0 20 20" aria-hidden="true"><path d="M8 5l5 5-5 5"/></svg>
            </a>
          </li>
        </ul>
        <!-- Дисклеймер — рядом с платежами, к которым он относится -->
        <p class="cost-group__note">
          <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 9v4.5M10 6.3v.2"/></svg>
          {{ st('calcSections.grandTotalDisclaimer', 'Расчёт предварительный. Итоговую сумму таможенных платежей утверждает таможенный орган при оформлении декларации.') }}
        </p>
      </div>

      <!-- Прочие расходы: в итог не входят — отдельная нейтральная подложка -->
      <div class="cost-group cost-group--other">
        <h3 class="overview-group">{{ st('calcSections.otherCosts', 'Прочие расходы') }}</h3>
        <ul class="cost-list cost-list--plain">
          <li class="cost-row cost-row--wrap" *ngFor="let item of otherCosts">
            <span class="cost-row__label">{{ st(item.key, item.fallback) }}</span>
            <strong class="cost-row__value" *ngIf="item.fromKzt">{{ st('calcSections.fromAmount', 'от {amount} ₸').replace('{amount}', fmt(item.fromKzt)) }}</strong>
            <strong class="cost-row__value" *ngIf="item.pctOfGoods && goodsValueKzt > 0">≈ {{ fmt(goodsValueKzt * item.pctOfGoods[0] / 100) }} – {{ fmt(goodsValueKzt * item.pctOfGoods[1] / 100) }} ₸</strong>
            <span class="cost-row__muted" *ngIf="!item.fromKzt && !(item.pctOfGoods && goodsValueKzt > 0)">{{ st('calcSections.onRequest', 'уточним по запросу') }}</span>
            <!-- Пояснение — отдельной строкой во всю ширину, чтобы на телефоне не сжималось в узкую колонку -->
            <small class="cost-row__note" *ngIf="item.noteKey">{{ st(item.noteKey, item.noteFallback || '') }}</small>
          </li>
        </ul>
      </div>

      <!-- Главное действие: кнопку и её поведение (заявка или обработка) задаёт страница расчёта -->
      <div class="overview-cta">
        <div class="overview-cta__text">
          <strong>{{ st('calcSections.ctaTitle', 'Возьмём поставку под контроль') }}</strong>
          <span>{{ st('calcSections.ctaText', 'Согласуем с вами точную стоимость прочих расходов и проведём поставку — от документов до выпуска товаров на таможне.') }}</span>
          <!-- У грузовладельца полный доступ уже есть — показываем только новым пользователям -->
          <div class="overview-cta__access" *ngIf="isPublicUser()">
            <em>{{ st('calcSections.fullAccessTitle', 'Вместе с сопровождением — полный доступ к платформе:') }}</em>
            <ul>
              <li *ngFor="let f of fullAccessFeatures">
                <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10.5l3.5 3.5L15 7"/></svg>
                {{ st(f.key, f.fallback) }}
              </li>
            </ul>
          </div>
        </div>
        <!-- Главное действие — заявка; кто сначала хочет спросить — пишет в WhatsApp с номером расчёта -->
        <div class="overview-cta__actions">
          <ng-content select="[overviewCta]"></ng-content>
          <a class="overview-cta__wa" *ngIf="!readOnly" [href]="ctaWhatsappLink" target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.6-1.2A9 9 0 1 0 12 3z"/><path d="M8.8 8.6c.2-.5.5-.5.8-.5h.5c.2 0 .4.1.5.4l.7 1.7c.1.2 0 .4-.1.6l-.5.6c-.1.1-.2.3 0 .5.3.6.8 1.2 1.4 1.7.6.5 1.2.8 1.8 1 .2.1.4 0 .5-.1l.6-.7c.2-.2.4-.2.6-.1l1.6.8c.2.1.4.2.4.4 0 .3 0 .9-.4 1.3-.4.5-1.3.9-2.1.8-1-.1-2.4-.6-3.8-1.8-1.6-1.4-2.4-2.9-2.6-3.8-.2-.9.1-1.5.5-1.8z"/></svg>
            {{ st('calcSections.ctaWhatsapp', 'Есть вопросы? Напишите в WhatsApp') }}
          </a>
        </div>
      </div>

    </section>

    <!-- Следующий шаг дорожной карты; в последнем разделе — обратно к сводке -->
    <nav class="section-next" *ngIf="section && section !== 'overview'">
      <a class="section-next__link" [routerLink]="['/calculations', calculation.id, nextSection?.id ?? 'overview']">
        <span class="section-next__label">{{ nextSection ? st('calcSections.next', 'Дальше') : st('calcSections.backTo', 'Вернуться') }}</span>
        <strong>{{ nextSection ? nextSectionTitle : st('calcSections.overview', 'Стоимость поставки') }}</strong>
        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 4l6 6-6 6"/></svg>
      </a>
    </nav>
  </div>
</div>
